import env from "flow/configuration/environment";
import ICLICommand from "flow/interfaces/ICLICommand";

export default {
    name: "env",
    description: "Displays all environment variables",
    options: [],
    arguments: [],
    callback: function (writer) {
        const variables = env.list();

        variables.forEach(v => {
            writer.output.writeLine(v.key + "=" + v.value);
        });

        return { input: "" };
    }
} as ICLICommand;
